/* src/app/emojimart/emojimart.component.scss */
.emoji-btn {
  padding: 8px;
}
.emoji-btn .button {
  height: 34px;
  color: #7a7a7a;
  padding-left: 6px;
  padding-right: 6px;
  border-radius: 0;
}
.emoji-btn .button:active {
  border-color: transparent;
}
.emoji-btn .button:focus {
  border-color: transparent;
}
.emoji-btn .dropdown-menu {
  min-width: 14em;
}
.emoji-btn .dropdown-menu .dropdown-content {
  height: 24em;
  width: 100%;
  overflow: hidden;
  position: relative;
  border-radius: 6px;
}
.emoji-btn .dropdown-menu .dropdown-content .dropdown-menu {
  position: absolute;
  top: 10px;
  bottom: 0px;
  left: 0px;
  right: -20px;
  overflow: auto;
}
.emoji-mart-category .emoji-mart-emoji span:hover {
  cursor: pointer !important;
}
/*# sourceMappingURL=emojimart.component.css.map */
